var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "banner-invest"
  }, [_c('div', {
    staticClass: "container "
  }, [_c('div', {
    staticClass: "banner-inner"
  }, [_vm._m(0), _c('div', {
    staticClass: "colums"
  }, [_c('p', {
    staticClass: "text-invest"
  }, [_vm._v(" Получайте ценные сведения от экспертов рынка и принимайте взвешенные решения, как и куда вложить свои средства. ")]), _vm.invType ? [_vm.invType === 1 ? [_c('ButtonAction', {
    staticClass: "main-action-btn",
    attrs: {
      "type": "submit",
      "message": "Присоединиться"
    },
    on: {
      "buttonAction": _vm.hasSubscription
    }
  })] : [_c('ButtonAction', {
    staticClass: "main-action-btn",
    attrs: {
      "type": "submit",
      "message": "Присоединиться"
    },
    on: {
      "buttonAction": _vm.hasProfileNoSubscription
    }
  })]] : [_c('ButtonAction', {
    staticClass: "main-action-btn",
    attrs: {
      "type": "submit",
      "message": "Присоединиться"
    },
    on: {
      "buttonAction": _vm.hasProfileNoSubscription
    }
  })]], 2), _c('div', {
    staticClass: "img-invest"
  })])])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('h2', {
    staticClass: "title-invest"
  }, [_vm._v("Откройте мир "), _c('span', [_vm._v("инвестиций")]), _vm._v(" по-новому ")]);
}]

export { render, staticRenderFns }